// Entry point for the build script in your package.json
import { Turbo } from "@hotwired/turbo-rails"
import "./controllers"
import * as bootstrap from "bootstrap"
import Rails from '@rails/ujs'
import './add_jquery'
import 'jquery-datetimepicker'
import 'jquery-ui'
import flatpickr from 'flatpickr'
import 'easy-autocomplete'
import '@didww/best_in_place'
import '@nathanvda/cocoon'
import "chartkick/highcharts"
import './scent_work'

Turbo.session.drive = false
Turbo.config.forms.mode = 'optin'
if (!window._rails_loaded) {
   Rails.start()
}
